import React from "react"
import { useSearchspringSuggestContext } from "@app/scripts/providers/searchspring"
import { useSearchspringTrendingContext } from "@app/scripts/providers/searchspring"

export function SearchDrawerMenu({
  showNoResults,
  title,
  noResults,
  provider,
}: {
  showNoResults?: boolean
  title?: string
  noResults?: string
  provider?: string
}) {
  const trendingContext = useSearchspringTrendingContext()
  const suggestContext = useSearchspringSuggestContext()

  const parseSearchQuery = (
    item: string | { token?: string; searchQuery?: string }
  ) => {
    if (typeof item === "string") return item
    if (item?.searchQuery) return item.searchQuery
    return item?.token ?? ""
  }

  const response =
    provider === "trending"
      ? trendingContext.response?.trending?.queries
      : provider === "suggest"
        ? suggestContext?.response?.suggested?.completed
        : []

  return (
    <div className="search-drawer--menu-container">
      {showNoResults ? (
        <p className="search-drawer--menu-no-results">{noResults}</p>
      ) : (
        <>
          <h3 className="search-drawer--menu-title">{title}</h3>
          <div className="search-drawer--menu-items-container">
            {response?.map((item, index) => {
              const searchQuery = parseSearchQuery(item)
              return (
                <a
                  key={index}
                  href={`/search?query=${searchQuery}`}
                  className="search-drawer--menu-item"
                >
                  {searchQuery}
                  <span className="search-drawer--menu-item-underline"></span>
                </a>
              )
            })}
          </div>
        </>
      )}
    </div>
  )
}
